import { Observable } from 'rxjs';
import { TipoInstituicaoEntidade } from './../shared/model/tipo-instituicao-entidade.model';
import { McticHttpClient } from '@mctic/ng-core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TipoInstituicaoEntidadeService {

  private ENDPOINT = "/sepin-backend/rest/tipos-instituicoes";

  constructor(private readonly mcticHttp: McticHttpClient) { }

  listar(): Observable<TipoInstituicaoEntidade[]> {
    return this.mcticHttp.get<TipoInstituicaoEntidade[]>(`${this.ENDPOINT}`);
  }
}
